export const replaceKey = (obj, newKey, oldKey) => {
  const newObj = {};
  delete Object.assign(newObj, obj, {[newKey]: obj[oldKey]})[oldKey];
  return newObj;
};

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}